export default {
  token: ''
}
